module.exports = __webpack_public_path__ + "a265db31771cb059c0a1535c1d6e6a24.svg";